import React, { useState } from "react";
import axios from "axios";
// 
const CreateAccount = () => {
  const [form, setForm] = useState({
    name: "",
    userId: "",
    password: "",
    contactNumber: "",
    email: "",
  });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setIsLoading(true);

    try {
      const res = await axios.post("https://api.happychd.com/api/admins", form);
      setSuccess("✅ Account created successfully!");
      setForm({ name: "", userId: "", password: "", contactNumber: "", email: "" });
    } catch (err) {
      setError(err?.response?.data?.message || "Registration failed ");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-100 to-blue-50 ">
      <div className="w-full max-w-md px-6 py-8">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-purple-600">Create Account</h1>
          <p className="text-gray-600 mt-2">Register as a new admin</p>
        </div>

        <div className="bg-white rounded-lg shadow-xl overflow-hidden">
          <div className="bg-purple-600 p-4">
            <h2 className="text-xl font-bold text-white text-center">Register</h2>
          </div>

          <form onSubmit={handleSubmit} className="px-6 py-6 space-y-4">
            {error && (
              <div className="p-3 bg-red-50 border-l-4 border-red-500 text-red-700 text-sm">
                <p className="font-medium">Error</p>
                <p>{error}</p>
              </div>
            )}
            {success && (
              <div className="p-3 bg-green-50 border-l-4 border-green-500 text-green-700 text-sm">
                <p className="font-medium">Success</p>
                <p>{success}</p>
              </div>
            )}

            <input
              name="name"
              placeholder="Full Name"
              value={form.name}
              onChange={handleChange}
              className="w-full border border-gray-300 px-4 py-3 rounded-md shadow-sm focus:ring-2 focus:ring-purple-500"
              required
            />
            <input
              name="userId"
              placeholder="User ID"
              value={form.userId}
              onChange={handleChange}
              className="w-full border border-gray-300 px-4 py-3 rounded-md shadow-sm focus:ring-2 focus:ring-purple-500"
              required
            />
            <input
              name="password"
              type="password"
              placeholder="Password"
              value={form.password}
              onChange={handleChange}
              className="w-full border border-gray-300 px-4 py-3 rounded-md shadow-sm focus:ring-2 focus:ring-purple-500"
              required
            />
            <input
              name="contactNumber"
              placeholder="Contact Number"
              value={form.contactNumber}
              onChange={handleChange}
              className="w-full border border-gray-300 px-4 py-3 rounded-md shadow-sm focus:ring-2 focus:ring-purple-500"
              required
            />
            <input
              name="email"
              type="email"
              placeholder="Email"
              value={form.email}
              onChange={handleChange}
              className="w-full border border-gray-300 px-4 py-3 rounded-md shadow-sm focus:ring-2 focus:ring-purple-500"
              required
            />

            <button
              type="submit"
              disabled={isLoading}
              className="w-full bg-purple-600 hover:bg-purple-700 text-white font-bold py-3 px-4 rounded-md transition"
            >
              {isLoading ? "Creating..." : "Create Account"}
            </button>

            <div className="mt-4 text-center text-sm text-gray-600">
              Already have an account?{" "}
              <a href="/login" className="font-medium text-purple-600 hover:text-purple-500">
                Login
              </a>
            </div>
          </form>
        </div>

        <div className="mt-6 text-center text-sm text-gray-500">
          <p>© 2025 HappyChd. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default CreateAccount;
